import { ReactElement, forwardRef, useRef, useImperativeHandle } from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";

export interface ICaptchaHandle {
    reset: () => void;
}

interface ICaptchaProps {
    onVerified: (token: string) => void;
}

const Captcha: React.ForwardRefRenderFunction<ICaptchaHandle, ICaptchaProps> = (props, forwardedRef): ReactElement => {
    const captchaRef = useRef<HCaptcha>(null);
    const captchaKey = process.env.GATSBY_HCAPTCHA_SITEKEY;

    useImperativeHandle(forwardedRef, () => ({
        reset() {
            captchaRef?.current?.resetCaptcha();
        },
    }));

    return <>{captchaKey ? <HCaptcha sitekey={captchaKey} onVerify={props.onVerified} ref={captchaRef} /> : <span>Captcha key not configured</span>}</>;
};

export default forwardRef(Captcha);
